import PropTypes from "prop-types";
import "./NewInSalesroute.css";
import { markReleaseAsSeen } from "../../../services/releaseNotesApi";
import { useTranslation } from "react-i18next";

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="new-two-column-b-icon">
    <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="#9CA3AF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const NewInSalesroute = ({ isOpen, onClose, release }) => {
  const { t } = useTranslation();

  if (!isOpen || !release) return null;

  const { id, version, title, features = [], improvements = [], bug_fixes = [] } = release;

  const handleClose = async () => {
    onClose();
  };

  return (
    <div className="whatsnew-overlay">
      <div className="whatsnew-modal">

        {/* Header */}
        <div className="whatsnew-header">
          <div className="whatsnew-icon-bg">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" className="whatsnew-icon">
              <path d="M5.99967 22C3.99967 23.68 3.33301 28.6667 3.33301 28.6667C3.33301 28.6667 8.31967 28 9.99967 26C10.9463 24.88 10.933 23.16 9.87967 22.12C9.36142 21.6253 8.67873 21.3395 7.96264 21.3174C7.24655 21.2952 6.54751 21.5383 5.99967 22Z" fill="white" fillOpacity="0.1" stroke="white" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16 20L12 16C12.7095 14.1592 13.6029 12.3947 14.6667 10.7333C16.2202 8.2493 18.3835 6.20405 20.9507 4.79211C23.5178 3.38016 26.4036 2.64848 29.3333 2.66665C29.3333 6.29332 28.2933 12.6667 21.3333 17.3333C19.6492 18.3983 17.8625 19.2916 16 20Z" fill="white" fillOpacity="0.1" stroke="white" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M11.9997 16H5.33301C5.33301 16 6.06634 11.96 7.99967 10.6667C10.1597 9.22667 14.6663 10.6667 14.6663 10.6667" fill="white" fillOpacity="0.1" stroke="white" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16 20V26.6667C16 26.6667 20.04 25.9333 21.3333 24C22.7733 21.84 21.3333 17.3333 21.3333 17.3333" fill="white" fillOpacity="0.1" stroke="white" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <h2>{t("What's New in Salesroute")}</h2>
            <span>{t("We're continuously improving to make your operations smoother.")}</span>
          </div>
        </div>

        <div className="whatsnew-content">

          {/* New Features */}
          {features.length > 0 && (
            <div className="whatsnew-section">
              <div className="whatsnew-section-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="whatsnew-section-title-icon">
                  <path d="M3.33325 11.6667C3.17555 11.6672 3.02094 11.623 2.88737 11.5391C2.75381 11.4553 2.64677 11.3353 2.5787 11.193C2.51063 11.0508 2.48432 10.8921 2.50283 10.7355C2.52133 10.5789 2.5839 10.4308 2.68325 10.3083L10.9332 1.80833C10.9951 1.73689 11.0795 1.68862 11.1724 1.67144C11.2653 1.65425 11.3613 1.66917 11.4447 1.71375C11.528 1.75832 11.5937 1.82991 11.631 1.91675C11.6683 2.00359 11.675 2.10053 11.6499 2.19166L10.0499 7.20833C10.0027 7.3346 9.98689 7.47043 10.0037 7.60417C10.0206 7.7379 10.0696 7.86556 10.1467 7.97618C10.2237 8.0868 10.3264 8.17709 10.446 8.23929C10.5656 8.3015 10.6985 8.33377 10.8332 8.33333H16.6666C16.8243 8.33279 16.9789 8.37701 17.1124 8.46084C17.246 8.54468 17.3531 8.6647 17.4211 8.80695C17.4892 8.94919 17.5155 9.10784 17.497 9.26444C17.4785 9.42105 17.4159 9.56919 17.3166 9.69166L9.06658 18.1917C9.00469 18.2631 8.92036 18.3114 8.82743 18.3285C8.73449 18.3457 8.63847 18.3308 8.55514 18.2862C8.4718 18.2417 8.40609 18.1701 8.3688 18.0832C8.33151 17.9964 8.32485 17.8995 8.34991 17.8083L9.94991 12.7917C9.99709 12.6654 10.0129 12.5296 9.99609 12.3958C9.97924 12.2621 9.9302 12.1344 9.85317 12.0238C9.77614 11.9132 9.67343 11.8229 9.55385 11.7607C9.43426 11.6985 9.30137 11.6662 9.16658 11.6667H3.33325Z" fill="#1D72E8" fillOpacity="0.1" stroke="#1D72E8" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>{t("New Features")}</span>
                <div className="whatsnew-section-title-new"><span>{t("NEW")}</span></div>
              </div>

              <div className="new-feature-cards">
                {features.map((feature) => (
                  <div className="new-feature-card" key={feature.id}>
                    
                    {feature.image ? (
                      <img src={feature.image} alt={feature.name} className="new-feature-icon" />
                    ) : (
                      <div className="new-feature-icon-bg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="new-feature-svg">
                          <path d="M16.6663 8.33335C16.6663 12.4942 12.0505 16.8275 10.5005 18.1659C10.3561 18.2744 10.1803 18.3331 9.99967 18.3331C9.81901 18.3331 9.64324 18.2744 9.49884 18.1659C7.94884 16.8275 3.33301 12.4942 3.33301 8.33335C3.33301 6.56524 4.03539 4.86955 5.28563 3.61931C6.53587 2.36907 8.23156 1.66669 9.99967 1.66669C11.7678 1.66669 13.4635 2.36907 14.7137 3.61931C15.964 4.86955 16.6663 6.56524 16.6663 8.33335Z" stroke="#1D72E8" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M10 10.8333C11.3807 10.8333 12.5 9.71402 12.5 8.33331C12.5 6.9526 11.3807 5.83331 10 5.83331C8.61929 5.83331 7.5 6.9526 7.5 8.33331C7.5 9.71402 8.61929 10.8333 10 10.8333Z" stroke="#1D72E8" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    )}
                    <div className="re-feature-content">
                      <h2>{feature.name}</h2>
                      <span>{feature.description}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="bt-whats-new">
            {/* Improvements */}
            {improvements.length > 0 && (
              <div className="whatsnew-section">
                <div className="whatsnew-section-title">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="whatsnew-section-title-icon">
                    <path d="M8.28086 12.9166C8.20647 12.6283 8.05615 12.3651 7.84555 12.1545C7.63494 11.9439 7.37176 11.7935 7.08336 11.7191L1.97086 10.4008C1.88364 10.3761 1.80687 10.3235 1.75221 10.2512C1.69754 10.1788 1.66797 10.0907 1.66797 9.99998C1.66797 9.90931 1.69754 9.82112 1.75221 9.74878C1.80687 9.67644 1.88364 9.62391 1.97086 9.59915L7.08336 8.27998C7.37166 8.20566 7.63477 8.05546 7.84537 7.84502C8.05596 7.63457 8.20634 7.37156 8.28086 7.08332L9.5992 1.97082C9.6237 1.88325 9.67618 1.8061 9.74863 1.75115C9.82108 1.69619 9.90951 1.66644 10.0004 1.66644C10.0914 1.66644 10.1798 1.69619 10.2523 1.75115C10.3247 1.8061 10.3772 1.88325 10.4017 1.97082L11.7192 7.08332C11.7936 7.37171 11.9439 7.6349 12.1545 7.8455C12.3651 8.0561 12.6283 8.20642 12.9167 8.28082L18.0292 9.59832C18.1171 9.62257 18.1946 9.67499 18.2499 9.74755C18.3052 9.8201 18.3351 9.90878 18.3351 9.99998C18.3351 10.0912 18.3052 10.1799 18.2499 10.2524C18.1946 10.325 18.1171 10.3774 18.0292 10.4016L12.9167 11.7191C12.6283 11.7935 12.3651 11.9439 12.1545 12.1545C11.9439 12.3651 11.7936 12.6283 11.7192 12.9166L10.4009 18.0292C10.3764 18.1167 10.3239 18.1939 10.2514 18.2488C10.179 18.3038 10.0905 18.3335 9.99961 18.3335C9.90868 18.3335 9.82025 18.3038 9.7478 18.2488C9.67535 18.1939 9.62287 18.1167 9.59836 18.0292L8.28086 12.9166Z" fill="#1D72E8" fillOpacity="0.1" stroke="#1D72E8" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span>{t("Improvements")}</span>
                </div>

                <div className="new-two-column">
                  {/* Split improvements into two columns */}
                  <ul>
                    {improvements
                      .filter((_, i) => i % 2 === 0)
                      .map((item) => 
                        <li key={item.id}>
                          <div className="imp-li-head">{item.text}</div>
                          <span className="imp-li-des">{item.description}</span>
                        </li>)}
                  </ul>
                  <ul>
                    {improvements
                      .filter((_, i) => i % 2 !== 0)
                      .map((item) => 
                      <li key={item.id}>
                          <div className="imp-li-head">{item.text}</div>
                          <span className="imp-li-des">{item.description}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            )}

            {/* Bug Fixes */}
            {bug_fixes.length > 0 && (
              <div className="whatsnew-section">
                <div className="whatsnew-section-title">
                  <span>{t("Bug Fixes")}</span>
                </div>
                <div className="new-two-column-b">
                  <ul>
                    {bug_fixes
                      .filter((_, i) => i % 2 === 0)
                      .map((item) => (
                        <li key={item.id}>
                          <div className="bugs-li-head"><CheckIcon />{item.text}</div>
                          <span className="bugs-li-des">{item.description}</span>
                        </li>
                      ))}
                  </ul>
                  <ul>
                    {bug_fixes
                      .filter((_, i) => i % 2 !== 0)
                      .map((item) => (
                        <li key={item.id}>
                          <div className="bugs-li-head"><CheckIcon />{item.text}</div>
                          <span className="bugs-li-des">{item.description}</span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="whatsnew-footer">
          <button className="gotit-button" onClick={handleClose}>
            {t("Got it")}
          </button>
        </div>
      </div>
    </div>
  );
};

NewInSalesroute.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  release: PropTypes.object,
};

export default NewInSalesroute;